<template>
  <section class="bg-t3-accent-dark/30 py-16 sm:py-24 font-t3-display" id="hours" aria-labelledby="hours-heading-t3">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-20">
      <h2 id="hours-heading-t3" class="text-2xl sm:text-3xl font-bold mb-8 text-slate-100">{{ $t('public.t3HoursAvailability') }}</h2>
      <PublicOpenStatusBadge :operating-hours="operatingHours" variant="contact" />
      <div class="space-y-4">
        <template v-if="hoursSummary.is24_7">
          <div
            class="inline-flex min-h-[44px] items-center gap-3 rounded-lg border border-white/10 bg-white/5 px-4 py-3"
            role="status"
            :aria-label="$t('public.open24_7')"
          >
            <span class="material-symbols-outlined text-2xl text-t3-primary shrink-0" aria-hidden="true">schedule</span>
            <span class="font-semibold text-slate-100">{{ $t('public.open24_7') }}</span>
          </div>
        </template>
        <template v-else>
          <div
            v-for="row in hoursSummary.perDay"
            :key="row.day"
            class="flex justify-between py-3 border-b border-white/5 gap-4"
          >
            <span class="text-slate-400">{{ $t('public.day' + row.day.charAt(0).toUpperCase() + row.day.slice(1)) }}</span>
            <span class="font-medium text-slate-100">{{ row.text === 'Closed' ? $t('public.closedNow') : row.text }}</span>
          </div>
        </template>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue'
import PublicOpenStatusBadge from '@/components/public/PublicOpenStatusBadge.vue'
import { getOperatingHoursSummary } from '@/utils/availability'

const props = defineProps({
  operatingHours: { type: Object, default: null },
})

const hoursSummary = computed(() => getOperatingHoursSummary(props.operatingHours))
</script>
